import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Technical SEO", desc: "Fix crawlability, indexation, structure, and page experience to unlock rankings." },
  { title: "Topical Authority", desc: "Cluster strategies that establish category leadership over time." },
  { title: "Local Search Growth", desc: "Map-pack and city-level optimization for location-sensitive businesses." },
  { title: "Content Optimization", desc: "On-page enhancements that improve relevance, depth, and search performance." },
  { title: "Link Earning Strategy", desc: "Authority-building programs grounded in quality, not manipulative shortcuts." },
  { title: "Search Intelligence", desc: "Reporting that ties ranking movement to pipeline and revenue outcomes." },
];

const SEOServices = () => (
  <StitchFeaturePage
    label="WEB & DIGITAL"
    title="SEO built for"
    titleAccent="compounding growth."
    subtitle="Long-horizon organic strategy with technical precision and commercial accountability."
    features={features}
    ctaLabel="START SEO STRATEGY"
  />
);

export default SEOServices;